import { registerComponent } from "helpers";

registerComponent(
  "peanuts-cart",
  class PeanutsCart extends HTMLElement {
    static woodstock = null;
    static miniCart = null;

    connectedCallback() {
      const form = this.closest("product-form")?.querySelector("form");
      const miniCart = document.querySelector("[data-mini-cart]");
      if (!form || !miniCart) return;

      this.boundOnFormSubmit = this.onFormSubmit.bind(this);
      form.addEventListener("submit", this.boundOnFormSubmit);
      this.form = form;

      PeanutsCart.ensureShared(
        miniCart,
        this.querySelector(".peanuts-woodstock"),
      );
    }

    disconnectedCallback() {
      this.form?.removeEventListener("submit", this.boundOnFormSubmit);
    }

    onFormSubmit() {
      PeanutsCart.miniCart?.classList.add("drawer--woodstock-flight");
    }

    static ensureShared(miniCart, woodstock) {
      if (!PeanutsCart.miniCart) {
        PeanutsCart.miniCart = miniCart;
        PeanutsCart.boundOnDrawerOpen =
          PeanutsCart.onDrawerOpen.bind(PeanutsCart);
        PeanutsCart.boundOnDrawerClose =
          PeanutsCart.onDrawerClose.bind(PeanutsCart);
        miniCart.addEventListener("drawerOpen", PeanutsCart.boundOnDrawerOpen);
        miniCart.addEventListener(
          "drawerClose",
          PeanutsCart.boundOnDrawerClose,
        );
      }

      if (!woodstock) return;

      if (!PeanutsCart.woodstock) {
        PeanutsCart.woodstock = woodstock;
        PeanutsCart.boundOnAnimationEnd =
          PeanutsCart.onAnimationEnd.bind(PeanutsCart);
        woodstock.addEventListener(
          "animationend",
          PeanutsCart.boundOnAnimationEnd,
        );
        document.body.append(woodstock);
        return;
      }

      if (woodstock !== PeanutsCart.woodstock) woodstock.remove();
    }

    static onDrawerOpen() {
      if (
        !PeanutsCart.miniCart.classList.contains("drawer--woodstock-flight")
      ) {
        return;
      }
      if (
        !PeanutsCart.woodstock ||
        PeanutsCart.woodstock.matches(":popover-open")
      ) {
        return;
      }
      PeanutsCart.woodstock.showPopover();
    }

    static onDrawerClose() {
      PeanutsCart.clearWoodstockFlight();
    }

    static onAnimationEnd(event) {
      if (event.animationName !== "woodstock-fade") return;
      PeanutsCart.clearWoodstockFlight();
    }

    static clearWoodstockFlight() {
      PeanutsCart.miniCart?.classList.remove("drawer--woodstock-flight");
      if (PeanutsCart.woodstock?.matches(":popover-open")) {
        PeanutsCart.woodstock.hidePopover();
      }
    }
  },
);
